<template lang="pug">
b-modal#editRewardRainSessionEndDate(
  ref="editRewardRainSessionEndDate"
  :title="$t('ui.combine.edit_reward_rain_session_end_date')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.name')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="rrs_name"
        required
        type="text"
        v-model="rrs_name"
        disabled
      )
    b-form-group(:label="$t('ui.start_date')").mb-0
      b-input-group(size="sm")
        date-picker.form-control-sm(
          ref="start_date"
          :config="localeDate"
          v-model="start_date"
          disabled
        )
    b-form-group(:label="$t('ui.start_time')").mb-0
      b-input-group(size="sm")
        date-picker.form-control-sm(
          ref="start_time"
          :config="localeTime"
          v-model="start_time"
          disabled
        )
    b-form-group(:label="$t('ui.end_date')").mb-0
      b-input-group(size="sm")
        date-picker.form-control-sm(
          ref="start_date"
          :config="localeDate"
          v-model="end_date"
        )
    b-form-group(:label="$t('ui.end_time')").mb-0
      b-input-group(size="sm")
        date-picker.form-control-sm(
          ref="end_time"
          :config="localeTime"
          v-model="end_time"
        )
    //- b-form-group(:label="$t('ui.end_date')").mb-0
    //-   b-form-select.col-4(v-model="endDt" size="sm")
    //-     option(value="one_week") {{ $t('ui.one_week') }}
    //-     option(value="two_week") {{ $t('ui.two_week') }}
    //-     option(value="one_month") {{ $t('ui.one_month') }}
    //-     option(value="two_month") {{ $t('ui.two_month') }}
    //-     option(value="six_month") {{ $t('ui.six_month') }}
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      session_id: "",
      rrs_name: "",
      start_date: this.$moment(new Date).format('YYYY-MM-DD'),
      start_time: "00:00:00",
      end_date: this.$moment(new Date).format('YYYY-MM-DD'),
      end_time: "23:59:59",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      localeTime: {
        format: "HH:mm:ss",
        useCurrent: true
      },
    };
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      let url = config.rewardRainSessionEndTimeUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        session_id: this.session_id,
        end_time: this.end_date + ' ' +this.end_time,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editRewardRainSessionEndDate.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_reward_rain_session_end_date", this.feedback.status);
                this.$refs.editRewardRainSessionEndDate.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.session_id = this.item.id;
      this.rrs_name = this.item.rrs_name;
      this.start_date = this.$moment(this.item.start_at).format('YYYY-MM-DD');
      this.start_time = this.$moment(this.item.start_at).format('HH:mm:ss');
      this.end_date = this.$moment(this.item.end_at).format('YYYY-MM-DD');
      this.end_time = this.$moment(this.item.end_at).format('HH:mm:ss');
    }
  },
};
</script>
